import styled from "styled-components";

export const Wrapper = styled.div`
  background-color: ${({ backgroundColor }: { backgroundColor: string }) =>
    backgroundColor ? backgroundColor : "#1517ac"};
  margin-bottom: 15px;
  color: white;
  height: 30px;
  padding: 0 10px;
  align-items: center;
  display: flex;
  font-weight: 600;
  font-size: 17px;
  justify-content: space-between;
  @media (max-width: 820px) {
    margin-bottom: 10px;
  }
`;

export const PlaylistTitle = styled.div``;

export const PlaylistMore = styled.div`
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
`;
